import React, { useState, useEffect } from "react";
import BottomNav from './component/BottomNav'
import Drawer from './component/Drawer'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Home from './component/Home'
import Positioning from './component/Positioning'
import Settings from './component/Settings'
import MyGroup from './component/Mygroup'
import NewMember from "./component/NewMember";
import Qr from "./component/QrScanner"
function App() {
  const [state, setState] = useState({
    mobileView: false
  })

  const { mobileView } = state;

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
  }, []);
  return (
    <Router>
      <div>
        {(mobileView) ? <BottomNav /> : <Drawer />}
        <Switch>
          <Route exact path="/">
            <Redirect to="map" />
          </Route>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/map">
            <Positioning />
          </Route>
          <Route path="/mygroup">
            <MyGroup />
          </Route>
          <Route path="/settings">
            <Settings />
          </Route>
          <Route path="/newmember">
            <NewMember />
          </Route>
          <Route path="/scanmember">
            <Qr />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
